var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (artists, undefined) {
buf.push("<div class=\"popover-header\"><span class=\"avant-garde-s-headline popover-left-side\">You might also like</span><span class=\"popover-close\">×</span></div><div class=\"popover-artists\"><ul>");
// iterate artists
;(function(){
  var $$obj = artists;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var artist = $$obj[$index];

buf.push("<li>");
var artist = artist
buf.push("<div class=\"artist-suggestion-row\"><img" + (jade.attr("src", artist.imageUrl(), true, true)) + " width=\"30\" height=\"30\"><a" + (jade.attr("href", artist.href(), true, true)) + " class=\"artist-suggestion-name\">" + (jade.escape(null == (jade_interp = artist.get('name')) ? "" : jade_interp)) + "</a><a data-state=\"follow\"" + (jade.attr("data-artist-slug", artist.get('id'), true, true)) + (jade.attr("data-artist-id", artist.get('_id'), true, true)) + " class=\"follow-button avant-garde-button-underlined\"></a></div></li>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var artist = $$obj[$index];

buf.push("<li>");
var artist = artist
buf.push("<div class=\"artist-suggestion-row\"><img" + (jade.attr("src", artist.imageUrl(), true, true)) + " width=\"30\" height=\"30\"><a" + (jade.attr("href", artist.href(), true, true)) + " class=\"artist-suggestion-name\">" + (jade.escape(null == (jade_interp = artist.get('name')) ? "" : jade_interp)) + "</a><a data-state=\"follow\"" + (jade.attr("data-artist-slug", artist.get('id'), true, true)) + (jade.attr("data-artist-id", artist.get('_id'), true, true)) + " class=\"follow-button avant-garde-button-underlined\"></a></div></li>");
    }

  }
}).call(this);

buf.push("</ul></div>");}.call(this,"artists" in locals_for_with?locals_for_with.artists:typeof artists!=="undefined"?artists:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;